"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;

var _util = require("../../../util");

const container = ({
  theme,
  cssProps
}) => {
  const {
    width = 'inline'
  } = cssProps;
  return {
    width: width === 'full' ? '100%' : 'auto',
    backgroundColor: (0, _util.color)(theme, 'background.black'),
    color: (0, _util.color)(theme, 'text.3'),
    borderRadius: 8
  };
};

exports.container = container;
//# sourceMappingURL=Toast.style.js.map